import { createContext, useContext, useState } from "react";
import { LOCALE_LANG_KEY } from "maven-lib/dist/states";
import { MvnLanguage } from "@maven-msg/lib/Message";

export const ECOA_FONT_SIZE = "EcoaFontSize";
export type EcoaFontSize = "SMALL" | "MEDIUM" | "LARGE";

interface LangContextProps {
  lang: MvnLanguage;
  fontSize: EcoaFontSize;
  setLang: (lang: MvnLanguage) => void;
  setFontSize: (size: EcoaFontSize) => void;
}

const LangContext = createContext<LangContextProps>({
  lang: MvnLanguage.KO,
  fontSize: "SMALL",
  setLang: () => {},
  setFontSize: () => {},
});

const language = window?.localStorage.getItem(LOCALE_LANG_KEY) as MvnLanguage;
const size = window?.localStorage.getItem(ECOA_FONT_SIZE) as EcoaFontSize;

function LangContextProvider(props: { lang?: MvnLanguage; size?: EcoaFontSize; children: React.ReactNode }) {
  const [lang, setLangState] = useState(props.lang || language || MvnLanguage.KO);
  const [fontSize, setFontSizeState] = useState(props.size || size || "SMALL");

  const setLang = (lang: MvnLanguage) => {
    setLangState(lang);
    window?.localStorage.setItem(LOCALE_LANG_KEY, lang);
  };
  const setFontSize = (size: EcoaFontSize) => {
    if (fontSize !== size) {
      setFontSizeState(size);
      window?.localStorage.setItem(ECOA_FONT_SIZE, size);
    }
  };

  return <LangContext.Provider value={{ lang, fontSize, setLang, setFontSize }}>{props.children}</LangContext.Provider>;
}

function useLangContext() {
  return useContext(LangContext);
}

export { LangContext, LangContextProvider, useLangContext };
